import React, { useContext, useEffect, useState } from "react";
import Account from "../../Services/accountServices";
import { Field, Formik } from "formik";
import { FormGroup, FormLabel } from "react-bootstrap";
import FormSelectField from "../../Components/FormSelectField";
import Loader from "../../Components/Loader";
import { AuthContext } from "../../Auth/Context/AuthContext";
function CurrencyRates(props) {
  const { user } = useContext(AuthContext);
  const [currencies, setCurrencies] = useState([]);
  const [currentRate, setCurrentRate] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchCurrencyRates = () => {
    Account.getCurrencyRate().then((acc) => {
      console.log(acc.data);
      setCurrentRate(acc.data);
    });
  };
  const fetchCurrencies = async () => {
    Account.getActivatedCurrencies().then((curr) => {
      const currency = curr.data.filter((op) => op.name === "AFN");
      setCurrencies(currency);
    });
  };
  useEffect(() => {
    fetchCurrencies();
    fetchCurrencyRates();
  }, []);
  const updateCurrency = async (values) => {
    setLoading(true);
    const data = {
      currencyId: values.currency,
      currencyName: currencies.find((op) => op.id === parseInt(values.currency))
        ?.name,
      currencyRate: values.currencyRate,
      branchId: user.branchId,
    };
    console.log("data", data);
    await Account.updateCurrencyRate(data)
      .then((item) => {
        fetchCurrencyRates();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  return (
    <>
      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="page-header">
            <div class="row">
              <div class="col">
                <h3 class="page-title">Currency Rates</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/">Dashboard</a>
                  </li>
                  <li class="breadcrumb-item active">Currency Rates</li>
                </ul>
              </div>
            </div>
          </div>
          <Loader loading={loading} />
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <h2>Current Rate</h2>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Currency Name</th>
                          <th>Rate</th>
                          <th>Create at</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRate.map((item) => {
                          return (
                            <tr>
                              <td>{item.currencyName}</td>
                              <td>{item.currencyRate}</td>
                              <td>{item.createdDate}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <Formik
                enableReinitialize
                initialValues={{
                  name: "",
                  currency: "",
                }}
                onSubmit={updateCurrency}
                // validationSchema={addAccountSchemaValidation}
              >
                {({ errors, touched, setFieldValue, handleSubmit }) => (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <div className="form-group w-100">
                        <FormLabel>Currency</FormLabel>
                        <FormSelectField
                          type="select"
                          name="currency"
                          setFieldValue={setFieldValue}
                        >
                          <option value="">Select</option>
                          {currencies &&
                            currencies.map((type) => (
                              <option value={type.id}>{type.name}</option>
                            ))}
                        </FormSelectField>
                        {errors.currency && touched.currency && (
                          <p style={{ color: "red" }}>{errors.currency}</p>
                        )}
                      </div>
                      <div className="form-group w-100">
                        <FormGroup>
                          <FormLabel>New Rate</FormLabel>
                          <Field
                            className="form-control"
                            type="number"
                            name="currencyRate"
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <div className="form-group">
                      <br />
                      <a
                        href="#"
                        className="btn btn-submit me-2"
                        onClick={handleSubmit}
                      >
                        Update
                      </a>
                    </div>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CurrencyRates;
